import { render, staticRenderFns } from "./DingZhi.vue?vue&type=template&id=55665519&scoped=true&"
import script from "./DingZhi.vue?vue&type=script&lang=js&"
export * from "./DingZhi.vue?vue&type=script&lang=js&"
import style0 from "./DingZhi.vue?vue&type=style&index=0&id=55665519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55665519",
  null
  
)

export default component.exports